// extracted by mini-css-extract-plugin
export var currencyInput = "_mj-1";
export var currencySymbol = "_mj-0";